import React, {Component} from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import configData from './config.json';

import Navbar from 'react-bootstrap/Navbar';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

import Home from './pages/Home';

import './App.css';
import './scss/style.scss';

export default class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isUserAuthenticated: false,
      exTools: null,
      pCode: '',
      pError: '',
      token: null,
      maxTimer: 0,
      dateLogon: null

    }

    this.pcode = null;
    this.token = null;
    this.onCodeChange = this.onCodeChange.bind(this);

  }
  
  componentDidUpdate() {
    if(this.pcode && this.pcode.length === 7) {
        this._fetchData();
    }
  }

  onCodeChange(event) {
    let code = event.target.value
    this.pcode = code;
    //console.log(this.pcode);
    this.setState({
        pCode: code,
    });
}


  _fetchData = async () => {
    var body = null;
    if(this.token) {
      //console.log('App Token', this.token);
      body =  "token=" + this.token;
      this.token = null;
    } else if(this.pcode) {
      //console.log('App pCode');
      body = "code=" + this.pcode;
      this.pcode = '';
    }

    if(body !== null) {
      const response = await fetch(configData.SERVER_URL, {
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
          },            
          method: 'POST',
          body: body,
      });
      const responseJson = await response.json();
      this.token = responseJson.user.Ergebnis;
      if(responseJson.user.OK === 'OK') {
       //console.log('fetchDataApp OK', responseJson.user);
        sessionStorage.setItem('exTools', JSON.stringify(responseJson.user));
        sessionStorage.setItem('exFilialen', JSON.stringify(responseJson.filialen));
        sessionStorage.setItem('artGroup', JSON.stringify(responseJson.artGroup));
        this.setState({isUserAuthenticated: true, exTools: responseJson.user});
        if(sessionStorage.getItem('filiale')) {
          this.setState({
            filiale: sessionStorage.getItem('filiale'),
            maxTimer: responseJson.user.TOKEN_TIME,
            dateLogon: Date.now()
          });
        } else {
          sessionStorage.setItem('filiale', responseJson.user.MitarbeiterFiliale);
          this.setState({
            filiale: responseJson.user.MitarbeiterFiliale,
            maxTimer: responseJson.user.TOKEN_TIME,
            dateLogon: Date.now()
          });
        }
      } else {
        sessionStorage.clear();
        this.setState({
          pCode:'', 
          pError: 'Ungültig oder Unbekannt!'
        });
      }
    }
  }

  componentDidMount() {
    if(sessionStorage.getItem('exTools')) {
      const response = sessionStorage.getItem('exTools');
      const responseJson = JSON.parse(response);
      if(responseJson.Ergebnis !== 'undefined') {
        this.token = responseJson.Ergebnis;
      }
    }
    this._fetchData();
  }


  render() {
    if(this.state.isUserAuthenticated && this.state.maxTimer > 0) {
     //console.log('App render', this.state.exTools);
      return (
            <BrowserRouter
              future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true,
              }}
            >
                <Routes>
                    <Route path="/" element={<Home data={this.state} page="home" maxTimer={this.state.maxTimer} dateLogon={this.state.dateLogon} />} />
                    <Route path="/aussteller" element={<Home data={this.state} page="aussteller" maxTimer={this.state.maxTimer} dateLogon={this.state.dateLogon} />}/>
                    <Route path="/verteilung" element={<Home data={this.state} page="verteilung" maxTimer={this.state.maxTimer} dateLogon={this.state.dateLogon} />}/>
                    <Route path="/imei" element={<Home data={this.state} page="imei" maxTimer={this.state.maxTimer} dateLogon={this.state.dateLogon} />}/>
                </Routes>
            </BrowserRouter>
      );
    } else {
      return (
          <>
          <Navbar fixed="top" className="bg-body-tertiary justify-content-between" bg="dark" data-bs-theme="dark">
          <Container fluid>

          <Navbar.Text>expert Ahaus, Borken, 2x Coesfeld</Navbar.Text>
          <Navbar.Text>Anmeldung</Navbar.Text>
          </Container>
          </Navbar>
          <div className="container" style={{padding: "4rem 20px"}}>
          <Card body>
              <Card.Text>
                Willkommen bei den expert Ahaus Tools! Bitte melde dich mit deinen Personal Code an!
              </Card.Text>
              <Form>
                <FloatingLabel controlId="pcode" label="Personal Code">
                  <Form.Control
                      type="password"
                      onChange={this.onCodeChange}
                      value={this.state.pCode}                
                      name="pcode"
                      placeholder="Personal Code"
                  />
                </FloatingLabel>
              </Form>
              <Card.Text style={{color:'red'}}>{this.state.pError}</Card.Text>
          </Card>
          </div>
          </>
      );
    }
  }
}

